import "../styles/membership.css";
import { useState, useEffect } from "react";
import UserController from "../services/user-controller";
import { getToken } from "../utility";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";

export default function MemberShip(props) {
	const [isLoading, setIsLoading] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [couponCode, setCouponCode] = useState("");
	const [coupon, setCoupon] = useState({
		isLoading: false,
		isSuccess: false,
		offPercent: 0,
		message: "",
	});
	const [profile, setProfile] = useState({
		userId: "",
		mobile: "",
		firstName: "",
		lastName: "",
		fullName: "",
		nationalId: "",
		email: "",
		gender: false,
		BirthDate: "",
		cardNumber: "",
		decile: 0,
		offPercent: 0,
		levelName: "",
		StateId: "",
		CityId: "",
		StoreId: "",
		cityName: "",
		cityFullName: "",
		membershipStatus: "",
		membershipExpireDate: null,
		membershipRemainDays: 0,
		membershipAmount: 0,
		isProfileCompleted: false,
	});
	const [errorMessage, setErrorMessage] = useState("");
	const [decile, setDecile] = useState(1);

	const decils = [
		{ value: 1, text: "دهک اول" },
		{ value: 2, text: "دهک دوم" },
		{ value: 3, text: "دهک سوم" },
		{ value: 4, text: "دهک چهارم" },
		{ value: 5, text: "دهک پنجم" },
		{ value: 6, text: "دهک ششم" },
		{ value: 7, text: "دهک هفتم" },
		{ value: 8, text: "دهک هشتم" },
		{ value: 9, text: "دهک نهم" },
		{ value: 10, text: "دهک دهم" },
	];
	//
	const userController = new UserController();

	useEffect(() => {
		getData();
	}, [coupon]);

	const getData = async function () {
		try {
			if (profile.userId) return;
			if (!getToken()) return;
			if (window.isBusy === true) return;
			setIsLoading(true);
			window.isBusy = true;
			var result = await userController.getProfile();
			if (result.isSuccess === false) throw result.message;

			if (result.startDate) result.startDate = new Date(result.startDate);
			if (result.expireDate) result.expireDate = new Date(result.expireDate);

			setProfile(result.value);
			setDecile(result.value.decile);
		} catch (error) {
			setErrorMessage(error.toString());
		}
		setIsLoading(false);
		window.isBusy = false;
	};

	//> getCoupon
	const getCoupon = async function () {
		try {
			setCoupon((prev) => ({ ...prev, isLoading: true }));
			const result = await userController.getCoupon(couponCode,"Membership");
			setCoupon((prev) => ({
				...prev,
				isLoading: false,
				isSuccess: result.isSuccess,
				message: result.message,
				offPercent: result.value.offPercent,
			}));
		} catch (error) {
			setErrorMessage(error.toString());
		} finally {
			setCoupon((prev) => ({ ...prev, isLoading: false }));
		}
	};

	//> createPayment
	const createPayment = async function () {
		try {
			setIsSaving(true);
			setErrorMessage("");
			const result = await userController.createMembershipOrder(
				decile,
				coupon.isSuccess === true ? couponCode : ""
			);
			if (result.isSuccess === false) throw result.message;
			window.location = result.value;
		} catch (error) {
			setErrorMessage(error.toString());
		} finally {
			setIsSaving(false);
		}
	};

	//> editProfile
	const editProfile = function () {
		window.location.href = "/#/register";
	};

	//>
	if (!getToken()) {
		window.location = "/#/login?returnUrl=/membership";
		return <></>;
	}
	return (
		<article className="membership">
			{isLoading === true && <>دریافت اطلاعات از سرور ...</>}
			<div className="header">اطلاعات عضویت</div>
			{profile.isProfileCompleted === false && (
				<div className="warning">
					<p>برای دسترسی به اطلاعات عضویت ابتدا پروفایل خود را تکمیل نمایید</p>
					<p>
						برای تکمیل پروفایل <a href="/#/profile">اینجا</a> را کلیک کنید
					</p>
				</div>
			)}
			{profile.isProfileCompleted === true && (
				<>
					{profile.membershipRemainDays > 0 && (
						<div className="success">
							<p>
								عضویت شما تا {profile.membershipRemainDays} روز دیگر فعال می
								باشد
							</p>
							<ul>
								<li>
									<label>نام ونام خانوادگی</label>
									<span></span>
									<strong>{profile.fullName}</strong>
								</li>
								<li>
									<label>شماره موبایل</label>
									<span></span>
									<strong>{profile.mobile}</strong>
								</li>
								<li>
									<label>کد ملی</label>
									<span></span>
									<strong>{profile.nationalId}</strong>
								</li>
								<li>
									<label>تاریخ پایان عضویت</label>
									<span></span>
									<strong>
										{new Date(profile.membershipExpireDate)?.toLocaleDateString(
											"fa-IR",
											{
												dateStyle: "short",
											}
										)}
									</strong>
								</li>
								<li>
									<label>روزهای باقیمانده از عضویت</label>
									<span></span>
									<strong>{profile.membershipRemainDays}</strong>
								</li>
								<li>
									<label>دهک فعلی شما</label>
									<span></span>
									<strong>{profile.decile}</strong>
								</li>
								<li>
									<label>سطح باشگاه مشتریان</label>
									<span></span>
									<strong>{profile.levelName}</strong>
								</li>
								<li>
									<label>درصد تخفیف</label>
									<span></span>
									<strong>{profile.offPercent}</strong>
								</li>
							</ul>
							<Button onClick={(e) => editProfile()}>ویرایش پروفایل</Button>
						</div>
					)}
					{profile.membershipRemainDays <= 0 && (
						<div className="info">
							<p>
								برای پرداخت حق عضویت ، بر روی دکمه پرداخت حق عضویت کلیک نمایید
							</p>
							<ul>
								<li>
									<label>نام ونام خانوادگی</label>
									<span></span>
									<strong>{profile.fullName}</strong>
								</li>
								<li>
									<label>شماره موبایل</label>
									<span></span>
									<strong>{profile.mobile}</strong>
								</li>
								<li>
									<label>کد ملی</label>
									<span></span>
									<strong>{profile.nationalId}</strong>
								</li>
								<li>
									<label>دهک فعلی شما</label>
									<span></span>
									<Dropdown
										value={profile.decile}
										onChange={(e) => setDecile(e.target.value)}
										options={decils}
										optionLabel="text"
										optionValue="value"
									/>
								</li>
								<li>
									<i></i>
									<Message
										severity="warn"
										content="⚠️ توجه: دهک‌بندی شما براساس اطلاعات خوداظهاری انجام می‌شود. در صورت مغایرت اطلاعات با داده‌های رسمی، دهک‌بندی اصلاح و در صورت تکرار، عضویت غیرفعال خواهد شد."
									/>
									<i></i>
								</li>
								<li>
									<label>مبلغ حق عضویت شش ماهه</label>
									<span></span>
									<strong>
										{profile.membershipAmount.toLocaleString("fa-IR")} ریال
									</strong>
								</li>

								<li>
									<label>کد تخفیف</label>
									<span></span>
									<div className="coupon">
										<InputText
											value={couponCode}
											onChange={(e) => setCouponCode(e.target.value)}
										/>
										<button
											onClick={() => getCoupon()}
											disabled={coupon.isLoading}
										>
											بررسی
										</button>
									</div>
								</li>
								{coupon.isSuccess === true && (
									<>
										<li>
											<label>درصد کوپن تخفیف</label>
											<span></span>
											<strong>{coupon.offPercent} %</strong>
										</li>
										<li>
											<label>مبلغ تخفیف</label>
											<span></span>
											<strong>
												{(
													coupon.offPercent *
													profile.membershipAmount *
													0.01
												).toLocaleString("fa-IR")}{" "}
												ریال
											</strong>
										</li>
										<li>
											<label>مبلغ نهایی قابل پرداخت</label>
											<span></span>
											<strong>
												{(
													profile.membershipAmount -
													coupon.offPercent * profile.membershipAmount * 0.01
												).toLocaleString("fa-IR")}{" "}
												ریال
											</strong>
										</li>
									</>
								)}
								{coupon.isSuccess === false && coupon.message && (
									<li>{coupon.message}</li>
								)}
							</ul>
							<button onClick={() => createPayment()} disabled={isSaving}>
								پرداخت حق عضویت
							</button>
						</div>
					)}
				</>
			)}
			<div>
				{errorMessage && <div className="text-danger">{errorMessage}</div>}
			</div>
		</article>
	);
}
